export default "__VITE_ASSET__PdJp9ZEE__"